"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchUserById = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var Users_1 = require("./Users");
var util_1 = require("../util");
var SearchInput_1 = require("./SearchInput");
var SearchUserById = function (state) {
    var _a = (0, react_1.useState)(), searchId = _a[0], setSearchId = _a[1];
    var _b = (0, react_1.useState)(), id = _b[0], setId = _b[1];
    var _c = (0, react_1.useReducer)(function (prev, next) { return prev + next; }, 0), loading = _c[0], addLoading = _c[1];
    var _d = (0, react_1.useReducer)(function (prev, current) {
        return current && id === current.id ? current : prev;
    }, undefined), user = _d[0], dispatchUser = _d[1];
    (0, react_1.useEffect)(function () {
        state.setSearchUsersById(user ? [user] : []);
    }, [user]);
    (0, react_1.useEffect)(function () {
        if (!id)
            return;
        addLoading(1);
        (0, api_1.fetchUserById)(id, true)
            .then(function (user) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = [user];
                    return [4 /*yield*/, (0, api_1.fetchProfile)(id)];
                case 1: return [2 /*return*/, _a.concat([_b.sent()])];
            }
        }); }); })
            .then(function (_a) {
            var user = _a[0], profile = _a[1];
            if (user) {
                dispatchUser((0, util_1.joinUserAndProfiles)((0, util_1.withLocationInfo)([user]), profile ? [profile] : [])[0]);
            }
            else {
                dispatchUser(undefined);
            }
            addLoading(-1);
        });
    }, [id]);
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: loading > 0, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: loading > 0, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { columns: 1, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Column, { children: [(0, jsx_runtime_1.jsx)(SearchInput_1.SearchInput, { value: searchId, onChange: function (e, _a) {
                                    var value = _a.value;
                                    return setSearchId(value);
                                }, placeholder: "usr_12345678-9012-abcd-efgh-hijk12345678" }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { onClick: function () { return setId(searchId); }, children: i18n_1.default.search })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsx)(Users_1.Users, { users: state.searchUsersById, menu: true }) })] })] }));
};
exports.SearchUserById = SearchUserById;
